import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { CurrentOrdersComponent } from './containers/current-orders/current-orders.component';
import { IonicModule } from '@ionic/angular';
import { SharedModule } from '../../shared/shared.module';
import { CurrentOrdersFooterComponent } from './components/current-orders-footer/current-orders-footer.component';
import { CurrentOrdersProgressComponent } from './components/current-orders-progress/current-orders-progress.component';
import { CurrentOrdersReadyComponent } from './components/current-orders-ready/current-orders-ready.component';
import { MaterialModule } from '../../core/modules/material.module';
import { TextMaskModule } from 'angular2-text-mask';
import { FormsModule } from '@angular/forms';

const routes: Routes = [
  {path: '', component: CurrentOrdersComponent}
];

@NgModule({
  declarations: [
    CurrentOrdersComponent,
    CurrentOrdersFooterComponent,
    CurrentOrdersProgressComponent,
    CurrentOrdersReadyComponent
  ],
  imports: [
    RouterModule.forChild(routes),
    CommonModule,
    IonicModule,
    SharedModule,
    MaterialModule,
    TextMaskModule,
    FormsModule
  ]
})
export class CurrentOrdersModule { }
